import { RouteKeys, RouteLabels, Routes } from '@constants';

export const toRoutes = (routes: RouteKeys[], _?: string) =>
  routes.map((key: RouteKeys) => ({
    label: RouteLabels[key],
    route: Routes[key],
  }));
